import React, { useState } from "react";
import "./Newsletter.css";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
const Newsletter = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    country: "",
    email: "",
    privacy_policy: false,
  });

  const [statusMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/newsletter`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      // const result = await response.json();

      if (response.ok) {
        // SweetAlert ile animasyonlu başarı mesajı
        Swal.fire({
          title: t("AlertSuccessTitle"),
          text: t("AlertSuccessMessage"),
          icon: "success",
          showConfirmButton: true,
          confirmButtonText: t("AlertSuccessBtn"),
          confirmButtonColor: "#000",
          timer: 3000,
          timerProgressBar: true,
        }).then(() => {
          // Formu sıfırla
          setFormData({
            name: "",
            surname: "",
            country: "",
            email: "",
            privacy_policy: false,
          });

          // Bootstrap Offcanvas'ı kapat
          const offcanvasElement = document.getElementById("offcanvasRight");
          if (offcanvasElement) {
            offcanvasElement.classList.remove("show");
            offcanvasElement.style.visibility = "hidden";
            offcanvasElement.removeAttribute("aria-modal");
            offcanvasElement.setAttribute("aria-hidden", "true");
            document.body.classList.remove(
              "offcanvas-backdrop",
              "show",
              "offcanvas-open"
            );
            // Sayfayı yenile
            window.location.reload();
          }
        });
      } else {
        Swal.fire({
          title: t("AlertErrorTitle"),
          text: t("AlertErrorMessage"),
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: t("AlertSuccessBtn"),
        });
      }
    } catch (error) {
      Swal.fire({
        title: t("AlertNetworkErrorTitle"),
        text: t("AlertNetworkErrorMessage"),
        icon: "error",
        confirmButtonColor: "#d33",
        confirmButtonText: t("AlertNetworkErrorBtn"),
      });
    }
  };

  return (
    <>
      <div
        className="offcanvas offcanvas-end p-5 pt-3"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <p className="mt-2">{t("NewsletterTitle")}</p>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <p className="mb-3 text-lighter">{t("NewsletterTitle")}</p>

          {statusMessage && (
            <div
              className={`alert ${
                statusMessage.type === "success"
                  ? "alert-success"
                  : "alert-danger"
              } fs-11 py-2 px-3`}
            >
              {statusMessage.text}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fs-11 text-lighter">
                {t("NewsletterFirstName")}
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fs-11 text-lighter">
                {t("NewsletterLastName")}
              </label>
              <input
                type="text"
                className="form-control"
                id="surname"
                name="surname"
                value={formData.surname}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fs-11 text-lighter">
                {t("NewsletterCountry")}
              </label>
              <input
                type="text"
                className="form-control"
                id="country"
                name="country"
                value={formData.country}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fs-11 text-lighter">
                {t("NewsletterEmail")}
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="privacy_policy"
                name="privacy_policy"
                checked={formData.privacy_policy}
                onChange={handleChange}
              />
              <label
                className="form-check-label fs-11 text-lighter"
                htmlFor="privacy_policy"
              >
                {t("NewsletterPrivacyText")}
                {""}
                <a href="/privacy-policy" className="text-dark mx-1">
                  {t("NewsletterPrivacyLink")}
                </a>
                {t("NewsletterPrivacyText2")}
              </label>
            </div>

            <div className="d-grid gap-2">
              <button
                type="submit"
                className="btn newsletterbtn text-lighter fs-11 p-3"
              >
                {t("NewsletterSubmitBtn")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Newsletter;
